"use client";

import { Button, type ButtonProps } from "@/components/ui/button";
import { Icon, type SupportedIcon } from "@/components/ui/icon";
import Link from "next/link";

export type AuthBackButtonProps = Omit<ButtonProps, "children"> & {
  href?: string;
  icon?: SupportedIcon;
  iconClassName?: string;
};

function BackIcon({
  icon,
  className,
}: { icon: SupportedIcon; className?: string }) {
  return <Icon icon={icon} className={`w-6 h-6 ${className}`} />;
}

export function AuthBackButton({
  type,
  variant,
  href,
  icon,
  iconClassName,
  ...rest
}: AuthBackButtonProps) {
  if (href) {
    const isExternal = href.startsWith("http");

    return (
      <Button
        asChild
        type={type ?? "button"}
        variant={variant ?? "ghost"}
        {...rest}
      >
        {isExternal ? (
          <a href={href} target="_blank" rel="noopener noreferrer">
            <BackIcon icon={icon ?? "ChevronLeft"} className={iconClassName} />
          </a>
        ) : (
          <Link href={href}>
            <BackIcon icon={icon ?? "ChevronLeft"} className={iconClassName} />
          </Link>
        )}
      </Button>
    );
  }

  return (
    <Button type={type ?? "button"} variant={variant ?? "ghost"} {...rest}>
      <BackIcon icon={icon ?? "ChevronLeft"} className={iconClassName} />
    </Button>
  );
}

AuthBackButton.displayName = "AuthBackButton";
